import { FC } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import styles from './partnerListInner.module.scss';
import { PartnerListComponent } from '@/components';

const titleComponents: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

const subtitleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.subtitle}>{children}</p>,
};

type Props = {
  slice: Content.PartnerListSlice;
};

export const PartnerListInner: FC<Props> = ({ slice }) => {
  return (
    <>
      <PrismicRichText
        field={slice.primary.title}
        components={titleComponents}
      />
      <PrismicRichText
        field={slice.primary.subtitle}
        components={subtitleComponents}
      />
      <div className={styles.listsWrapper}>
        <PartnerListComponent list={slice.primary.list_1} />
        <PartnerListComponent list={slice.primary.list_2} />
      </div>
    </>
  );
};
